import { Button, CircularProgress } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React, { useState } from "react";
// import { OrderService } from "../services/OrderService";
import { getNewOrders } from '../../services';

const propTypes = {
  classes: PropTypes.object.isRequired,
  disabled: PropTypes.bool
};

function RequestNewOrdersButton({ classes, cb, disabled }) {
  // const orderService = new OrderService();
  const [isLoading, setIsLoading] = useState(false);

  function requestNewOrders() {
    setIsLoading(true);
    // orderService.
      getNewOrders()
      .then(data => {
        setIsLoading(false);
        cb();
      })
      .catch(error => console.log(error));
  }
  return (
    <Button disabled={isLoading} variant="contained" onClick={requestNewOrders}>
      {isLoading ? <CircularProgress size={25} /> : "Refresh Orders"}
    </Button>
  );
}

const styles = theme => ({});

RequestNewOrdersButton.propTypes = propTypes;

export default withStyles(styles)(RequestNewOrdersButton);

